export const appsAppGroupIdChartsUsers = "/apps/:app_group_id/charts/users";
